'use client';

import { ComponentType, FC, useEffect, useState } from 'react';
import { IPlayerProps } from '@lottiefiles/react-lottie-player';
import clsx from 'clsx';

import LoadingIndicatorAnimation from './animation.json';

type Props = Pick<IPlayerProps, 'style'> & {
    className?: string;
};

const LoadingIndicator: FC<Props> = ({ className, style }) => {
    const [Player, setPlayer] = useState<ComponentType<IPlayerProps> | null>(
        null
    );

    useEffect(() => {
        // Dynamically import the Player component only on the client side
        import('@lottiefiles/react-lottie-player').then((module) => {
            setPlayer(() => module.Player);
        });
    }, []);

    // Show a simple loading state while the Player component loads
    if (!Player) {
        return (
            <div className={clsx(className)} style={style}>
                <div>Loading...</div>
            </div>
        );
    }

    return (
        <div className={clsx(className)}>
            <Player
                autoplay
                loop
                src={LoadingIndicatorAnimation}
                style={style}
            />
        </div>
    );
};

export default LoadingIndicator;
